import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import VideoPlayer from 'components/VideoPlayer/VideoPlayer';
import Teamwork from './Teamwork';
import ConflictSimulatorNeeds from './ConflictSimulatorNeeds';
import Discuss from './Discuss';
import SomethingWrong from 'components/SomethingWrong/SomethingWrong';
import { isFunction } from 'lodash';
import CreateAccountStepItem from 'components/StepItems/CreateAccountStepItem';

const LessonStepper = ({
  CHEATS,
  LessonType,
  CurrentSelectedStepItem,
  setCurrentSelectedStepItem,
  IsCurrentSelectedStepItemCompleted,
  stepRecipe,
  stepItemId,
  handleCloseStepper,
  playRefAudio,
  pauseRefAudio,
  teamworkMusicRef,
  VolumeSwitchState,
  addEvent,
  classes,
  MaxStepItems,
  AnimalType,
  instructorName,
  LessonDetails
}) => {
const { t } = useTranslation();
const stepItemsRecipe = stepRecipe.stepItems;

const [IsVideoWatchedTillEnd, setIsVideoWatchedTillEnd] = useState(false);
const [VideoSeekValue, setVideoSeekValue] = useState(0);

  const generateStepElement = (stepItemRecipe, onContinue, onBack, onExit, addEvent) => {
    switch (stepItemRecipe.pageState) {
      case 'video':
        return (
            <VideoPlayer
              URL={t(stepItemRecipe.url)}
              IsVideoWatchedTillEnd={IsVideoWatchedTillEnd}
              setVideoSkipped={() => {}}
              onContinue={onContinue}
              onBack={onBack}
              onExit={onExit}
              addEvent={addEvent}
              stepItemId={stepItemId}
              IsCurrentSelectedStepItemCompleted={IsCurrentSelectedStepItemCompleted}
              VideoOnEnded={false}
              setVideoOnEnded={() => {}}
              setVideoExited={() => {}}
              seek={VideoSeekValue}
              volume={VolumeSwitchState}
              classes={'fullScreen '}
              VideoPlayerLoop={false}
              CurrentSelectedStepItem = {CurrentSelectedStepItem}
              isSkippable = {stepItemRecipe.isSkippable && stepItemRecipe.isSkippable}
            />
        );
      break
      case 'teamWork':
        return (
          <Teamwork
            URL={t(stepItemRecipe.url)}
            IsVideoWatchedTillEnd={IsVideoWatchedTillEnd}
            playRefAudio={playRefAudio}
            pauseRefAudio={pauseRefAudio}
            teamworkMusicRef={teamworkMusicRef}
            stepItemId={stepItemId}
            onContinue={onContinue}
            onBack={onBack}
            addEvent={addEvent}
            CurrentSelectedStepItem = {CurrentSelectedStepItem}
            bullets = {stepItemRecipe.bullets}
            tips = {stepItemRecipe.tips}
            AnimalType ={AnimalType}
            instructorName ={instructorName}
            LessonDetails={LessonDetails}
          />
        );
      break
      case 'discuss':
        return (
          <Discuss
            img={stepRecipe.stepItems[CurrentSelectedStepItem].img}
            discussTitle={stepRecipe.stepItems[CurrentSelectedStepItem].discussTitle}
            discussSubtitle={stepRecipe.stepItems[CurrentSelectedStepItem].discussSubtitle}
            stepItemId={stepItemId}
            onContinue={onContinue}
            onBack={onBack}
            addEvent={addEvent}
            CurrentSelectedStepItem = {CurrentSelectedStepItem}
          />
        );
      break
      case "needCards" :
          return (
              <ConflictSimulatorNeeds
                  addEvent={addEvent}
                  stepName={stepRecipe.name}
                  taskTitle={stepRecipe.taskTitle}
                  taskSubTitle={stepRecipe.taskSubTitle}
                  CurrentSelectedStepItem = {CurrentSelectedStepItem}
                  cards = {stepRecipe.stepItems[CurrentSelectedStepItem].cards}
                  setConflictSimulatorNeedsReplay = {onBack}
                  backgroundColor = {stepRecipe.stepItems[CurrentSelectedStepItem].backgoundColor}
                  stepItemId={stepItemId}
                  onBack={onBack}
                  thumbnailUrl = {stepRecipe.stepItems[CurrentSelectedStepItem].thumbnailUrl}
              />
          )
      break
      case 'createAccount':
        return (
          <CreateAccountStepItem
            onContinue={onContinue}
            onBack={onBack}
            addEvent={addEvent}
            stepItemId={stepItemId}
            CurrentSelectedStepItem={CurrentSelectedStepItem}
            isSkippable={!!stepItemRecipe.isSkippable}
          />
        );
      break
      default:
        return null;
    }
  };

  const onContinue = async () => {};

  const onBack = async () => {
    try { addEvent && addEvent('back', 'stepItem', 'CreateAccountStepItem', CurrentSelectedStepItem, stepItemId); } catch(_) {}
    if (CurrentSelectedStepItem === 0) {
      handleCloseStepper();
    } else {
      setCurrentSelectedStepItem(CurrentSelectedStepItem - 1);
    }
  };

  const onExit = async () => {
    const stepOnExit = currentStepItem?.onExit;
    if (isFunction(stepOnExit)) await stepOnExit();
    exitStepper();
  };

  const onFinish = () => {
    handleCloseStepper();
  };

  const exitStepper = () => {
    handleCloseStepper();
  };

  const buildStepItems = (stepItemsRecipe) => {
    return stepItemsRecipe.map((stepItemRecipe, index) => ({
      index: index,
      title: t(stepItemRecipe.title),
      element: generateStepElement(stepItemRecipe, onContinue, onBack, onExit, addEvent),
    }));
  };

  const stepItemsArr = buildStepItems(stepItemsRecipe);

  const stepItems = stepItemsArr.filter(({ stepDisabled }) => !stepDisabled);
  const maxStepIndex = stepItems.length - 1;
  const currentStepItem = stepItems[CurrentSelectedStepItem];

  return (
    <>
      {currentStepItem?.element ? currentStepItem?.element : <SomethingWrong/>}
    </>
  );
};

export default LessonStepper;
